export default "query {\n  getSubProjectUnit \n}";